<template>
  <div class="UserAccount">
    <div class="titlePage">Error en email</div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 totalform">
            <va-notification color="danger" v-if="checkTerminos" class="refNoData">Su cuenta de correo no está registrada en nuestro sistema. Si es docente o administrativo por favor contactar con gestión humana y si es estudiante por favor contactar con servicio al estudiante.</va-notification>
          <ValidationObserver ref="obsFieldsUpdate">
            <FormUpdateClient
              v-if="renderComponent1"
              :FieldsForm="formUpdate"
              :ModelForm="formUpdModel"
              :method="executeProcess"
            />
          </ValidationObserver>
          <div class="col-md-6 float-left">
            <div class="refNoData">
                <va-notification color="info" v-if="addRExito" class="refNoData">Se actualizo correctamente el usuario solicitado.</va-notification>
                <va-notification color="danger" v-if="refNoUpdate" class="refNoData">La actualizacion del usuario presento un fallo.</va-notification>
                <va-notification color="danger" v-if="refWSUpdate" class="refNoData">El servicio que ejecuta la actualización no se encuentra activo.</va-notification>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormUpdateClient from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import FormAddress from '@/components/Forms.vue'

export default {
  name: 'Account',
  components: {
    FormUpdateClient,
    FormAddress,
  },
  data () {
    return {
      formUpdModel: {
        idUpdatedBy: this.$session.get('IberoJWTAdminLogin').idPerson,
        IdBanner: '',
      },
      formAddModel: {
      },
      renderComponent1: false,
      checkTerminos: false,
      addRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
      formAddress: [
      ],
      formUpdate: [
        {
          id: 'IdBanner',
          model: 'IdBanner',
          name: 'Email Login',
          type: 'informative',
          placeholder: 'Email Login',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-6',
        },
      ],
    }
  },
  methods: {
    limpiaref () {

    },
    updateForm () {
    },
    executeProcess: function (event) {
    },
    executeAddress: function () {
    },
    dataformat: function (InfDaT) {
    },
    dataObjFindJs: function (infoDaT, FinDaT) {
    },
    dataObjAllFind: function (infoDaT, FinDaT) {
    },
    callLoadData: function () {
      this.formUpdModel.IdBanner = this.$session.get('IberoJWTAdmin').unique_name // this.$session.get('IberoJWTAdminLogin').idBanner
    },
  },
  created: function () {
    this.callLoadData()
    IberoHelpers.forceRerender1(this)
    this.checkTerminos = true
  },
}
</script>

<style>
.totalform {
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 30px;
  background-color: #ffffff;
}
.linkTerm {
  color: #222 !important;
}
.refNoData {
  font-weight: bold;
  margin-top: 25px;
}
</style>
